import { sharedEnvironment } from '@vinnova/environments';

export const environment = {
  production: sharedEnvironment.utv.production,
  name: sharedEnvironment.utv.name,
  forhandsgranskaUrl: sharedEnvironment.utv.forhandsgranskaUrl,
  bpUrl: sharedEnvironment.utv.bpUrl,
  etjansterCommonUrl: sharedEnvironment.utv.etjansterCommonUrl,
  cookieDomain: sharedEnvironment.utv.cookieDomain,
  forhandsgranskaApiUrl: `${sharedEnvironment.utv.forhandsgranskaApiUrl}`,
  etjansterCommonApiUrl: `${sharedEnvironment.utv.gatewayUrl}/etjanster`,
  resourceStringUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring/forhandsgranska`,
  sprakHanteringApiUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring`,
  oregApiUrl: `${sharedEnvironment.utv.gatewayUrl}/organisationsregistret`,
  logServiceApiUrl: `${sharedEnvironment.utv.gatewayUrl}/logger`,
  projektUrl: sharedEnvironment.utv.projektUrl,
  externalLinks: sharedEnvironment.utv.externalLinks,
  baseGatewayUrl: sharedEnvironment.utv.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.utv.apimSubscriptionKey,
  msalConfig: {
    ...sharedEnvironment.msalConfig(
      sharedEnvironment.utv.forhandsgranskaApiUrl,
      'f1866331-f135-4e55-a00c-b842c59ce346',
      '7d70ad87-bc0d-42c1-8991-f92764304052',
      sharedEnvironment.utv.forhandsgranskaUrl,
    ),
    allowRedirectInIframe: true,
  },
  effektaArendekortUrl: `${sharedEnvironment.utv.effektaUrl}/Platina/modules/customized/navigera/arende.aspx`,
  effektaUrl: sharedEnvironment.utv.effektaUrl,
};
